import React from 'react'
import { createCartUrl } from '../utils/cart'
import { LeshenPhoneCTA, useMapi } from '@leshen/gatsby-theme-leshen'

function DynamicPhoneCTA() {
  const { rotatedNumber, sessionPromoCode, requestId } = useMapi()
  const cartURL = createCartUrl(rotatedNumber, sessionPromoCode, requestId)
  return (
    <LeshenPhoneCTA
      color="primary"
      cobra="Hide CTA"
      requestId={requestId}
      cobraCartUrl={cartURL}
    >
      Call
    </LeshenPhoneCTA>
  )
}

export default DynamicPhoneCTA
